
import { curryFactory, removeEmpty } from '~/utils/tools.js'
export default {
  name: 'ToggleWrap',
  author: '@wei',
  props: {
    title: {
      type: String,
      default: '轻松搭建满意度问卷',
    },
    desc: {
      type: Array,
      default: null,
    },
    // PC端
    src: {
      type: String,
      default: '',
    },
    // 移动端展示图片
    mobileSrc: {
      type: String,
      default: '',
    },
    // 布局模式
    align: {
      type: String,
      default: '',
    },
    btnText: {
      type: String,
      default: '立即创建',
    },
    maxTop: {
      type: String,
      default: '182px',
    },
    minTop: {
      type: String,
      default: '182px',
    },
    //  测试
    href: {
      type: String,
      default: '',
    },
    // 图片宽度
    width: {
      type: String,
      default: '',
    },
    // 是否内容前是否展示点
    showDot: {
      type: Boolean,
      default: false,
    },
    // 是否是自定义样式
    useCustomClass: {
      type: Boolean,
      default: false,
    },
    fontSizes: {
      type: Array,
      default: () => [],
    },
    // 是否需要校验登录
    needLogin: {
      type: Boolean,
      default: true,
    },
    // 外部控制是否展示按钮
    hideButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const createObject = curryFactory('desc', 'src', 'mobileSrc', 'btnText', 'align')
    return {
      defData: new Map([
        [
          '好玩的答题抽奖定制',
          createObject(
            [
              '抽奖资格 | 可根据答题情况限制',
              '抽奖频率与次数 | 抽几次中几次随心定',
              '奖品类型 | 支持微信红包、自定义奖品',
            ],
            'https://s1.wenjuan.com/assets/images/homesite/scence-page/knowledge/nav-bar/pc-819.png',
            'https://s1.wenjuan.com/assets/images/homesite/scence-page/knowledge/nav-bar/m-819.png',
            '免费创建',
            'left'
          ),
        ],
        [
          '浓烈的活动氛围营造',
          createObject(
            ['活动封面模块化配置', '支持倒计时、排行榜', '支持背景音乐'],
            'https://s1.wenjuan.com/assets/images/homesite/scence-page/knowledge/nav-bar/pc-820.png',
            'https://s1.wenjuan.com/assets/images/homesite/scence-page/knowledge/nav-bar/m-820.png',
            '免费创建',
            'right'
          ),
        ],
        [
          '丰富的竞赛模式支持',
          createObject(
            ['抽奖资格 | 可根据答题情况限制', '答对能进入下一题，比赛神器', '先付费后考试，付费考试不用愁'],
            'https://s1.wenjuan.com/assets/images/homesite/scence-page/knowledge/nav-bar/pc-821.png',
            'https://s1.wenjuan.com/assets/images/homesite/scence-page/knowledge/nav-bar/m-821.png',
            '免费创建',
            'left'
          ),
        ],
        [
          '强大的知识竞赛支撑',
          createObject(
            [
              '赛前 | 题目一键导入、分值批量设置',
              '赛中 | 稳定支持千万人在线、无限答卷',
              '赛后 | 趣味排行榜、自动评分报告',
            ],
            'https://s1.wenjuan.com/assets/images/homesite/scence-page/knowledge/nav-bar/pc-822.png',
            'https://s1.wenjuan.com/assets/images/homesite/scence-page/knowledge/nav-bar/m-822.png',
            '免费创建',
            'right'
          ),
        ],
        [
          '轻松搭建满意度问卷',
          createObject(
            ['专业模板贴合行业需求，一键引用', '多种打分题型，量化主观感受', '多维度专业满意度报告助力数据分析'],
            require('~/assets/image/scence/big-items/md-item01.png'),
            require('~/assets/image/scence/big-items/m-item01.png'),
            '立即创建',
            'left'
          ),
        ],
        [
          '强大的分发与答题体验',
          createObject(
            [
              '生成多个问卷链接，区分人群来源，精准投放',
              '邮件分享、短信分享、限定白名单直达目标人群',
              '支持小程序答题、自定义链接卡片形象',
            ],
            require('~/assets/image/scence/big-items/md-item10.png'),
            require('~/assets/image/scence/big-items/m-item10.png'),
            '立即创建',
            'right'
          ),
        ],
        [
          '即时生成满意度报告',
          createObject(
            ['满意度总体得分、维度得分一目了然', '满意率占比、分值占比一手掌控', '支持各项细节指标对比分析'],
            require('~/assets/image/scence/big-items/md-item03.png'),
            require('~/assets/image/scence/big-items/m-item03.png'),
            '立即创建',
            'left'
          ),
        ],
        [
          '多种方式高效创建问卷',
          createObject(
            ['45+题型组件轻松选取', '专业模板免费引用', '支持文本、word、excel导入'],
            require('~/assets/image/scence/big-items/md-item04.png'),
            require('~/assets/image/scence/big-items/m-item04.png'),
            '立即创建',
            'left'
          ),
        ],
        [
          '编辑功能强大易用',
          createObject(
            ['复杂问卷逻辑轻松设置', '超多题目配置项，满足您的细节需求', '自定义问卷外观，打造您的专属风格'],
            require('~/assets/image/scence/big-items/md-item09.png'),
            require('~/assets/image/scence/big-items/m-item09.png'),
            '立即创建',
            'right'
          ),
        ],
        [
          '多渠道分发 、快速收集',
          createObject(
            [
              '链接、二维码、海报等高效分享方式',
              '样本服务、互答广场、红包问卷助你快速收集',
              '多种限定答题方式，样本收集更准确',
            ],
            require('~/assets/image/scence/big-items/md-item06.png'),
            require('~/assets/image/scence/big-items/m-item06.png'),
            '立即创建',
            'left'
          ),
        ],
        [
          '答题体验流畅顺滑',
          createObject(
            [
              '答题页全新升级，只为更好的用户体验',
              '多端完美适配，更好的呈现您的问卷',
              '支持断点续答、修改已填等多种答题设置',
            ],
            require('~/assets/image/scence/big-items/md-item02.png'),
            require('~/assets/image/scence/big-items/m-item02.png'),
            '立即创建',
            'right'
          ),
        ],
        [
          '可视化图表实时呈现',
          createObject(
            ['专业的分析报表，可直接引用到PPT', '支持自定义交叉分析图表', '原始数据支持多种格式导出'],
            require('~/assets/image/scence/big-items/md-item07.png'),
            require('~/assets/image/scence/big-items/m-item07.png'),
            '立即创建',
            'left'
          ),
        ],
        [
          '无缝连接SPSSPRO在线数据分析',
          createObject(
            [
              '问卷网数据一键导入，免费专业好用',
              '多种数据分析模型，自动生成可视化报告',
              '数据支持自定义绘图，从数据到图表只需一秒',
            ],
            require('~/assets/image/scence/big-items/md-item08.png'),
            require('~/assets/image/scence/big-items/m-item08.png'),
            '立即创建',
            'right',
            {
              title: '无缝连接SPSSPRO',
              subTitle: '在线数据分析',
              subBtnText: '了解SPSSPRO ',
              subHref: 'https://www.spsspro.com/?utm_source=wenjuan_scene',
            }
          ),
        ],
        [
          '关联钉钉通讯录',
          createObject(
            ['关联钉钉企业通讯录组织架构', '支持通讯录按部门全选', '一键应用内发送答题通知'],
            `${this.$cdnhome}scence-page/dingding/manbar-1-md.png`,
            `${this.$cdnhome}scence-page/dingding/manbar-1-md.png`,
            '',
            'left',
            {
              unButtons: true,
            }
          ),
        ],
        [
          '查看个人答题情况',
          createObject(
            ['支持查看待填写项目，避免遗漏答题', '支持查看已填写项目，回顾已填信息'],
            `${this.$cdnhome}scence-page/dingding/manbar-2-md.png`,
            `${this.$cdnhome}scence-page/dingding/manbar-2-md.png`,
            '',
            'right',
            {
              unButtons: true,
            }
          ),
        ],
        [
          '监控问卷收集进度',
          createObject(
            ['自动关联答题人部门、姓名等信息', '自动统计已作答人员与人数'],
            `${this.$cdnhome}scence-page/dingding/manbar-3-md.png`,
            `${this.$cdnhome}scence-page/dingding/manbar-3-md.png`,
            '',
            'left',
            {
              unButtons: true,
            }
          ),
        ],
        [
          '催促作答',
          createObject(
            ['支持查看未作答人员名单并一键催促', '支持催促当日未作答人员，适配每日答题场景'],
            `${this.$cdnhome}scence-page/dingding/manbar-4-md.png`,
            `${this.$cdnhome}scence-page/dingding/manbar-4-md.png`,
            '',
            'right',
            {
              unButtons: true,
            }
          ),
        ],
        [
          '质量高 专业顾问审核跟进',
          createObject(
            [
              '问卷网承诺，每份问卷均经专业顾问审核，保障真实性和有效性',
              '我们的服务模式让您只需支付有价值数据，无需为无效数据承担风险',
            ],
            `${this.$cdnhome}scence-page/collect/service-1.png`,
            `${this.$cdnhome}scence-page/collect/service-1.png`,
            '开启调研',
            'right',
            {
              unButtons: this.hideButton,
              htmlTitle: "<span class='color-primary'>质量高</span> 专业顾问审核跟进",
              textStyle: { 'padding-left': '50px', 'padding-right': '0px' },
              textBkg: `${this.$cdnhome}scence-page/collect/text-bkg.png`,
              customClass: 'collect-post',
            }
          ),
        ],
        [
          '抽样准 多元化样本库',
          createObject(
            [
              '问卷网答题日活跃用户超百万，构建了包含全国各地、各年龄段、性别、职业、行业、兴趣爱好及教育程度的多元样本库',
              '我们的专业团队会精准分析问卷目标，确保问卷精准触达合适的受众',
            ],
            `${this.$cdnhome}scence-page/collect/service-2.png`,
            `${this.$cdnhome}scence-page/collect/service-2.png`,
            '开启调研',
            'left',
            {
              unButtons: this.hideButton,
              htmlTitle: "<span class='color-primary'>抽样准</span> 多元化样本库",
              textStyle: { 'padding-left': '0px', 'padding-right': '50px' },
              textBkg: `${this.$cdnhome}scence-page/collect/text-bkg.png`,
              customClass: 'collect-post',
            }
          ),
        ],
        [
          '交付快 通用样本1~3天交付',
          createObject(
            [
              '10年+问卷收集经验，系统智能识别目标人群的活跃时段。人工实时跟进配额收集进度，动态调整投放策略',
              '高质量的样本投放+人工快速响应。73.2%项目有效样本交付时间缩短至3天内',
            ],
            `${this.$cdnhome}scence-page/collect/service-3.png`,
            `${this.$cdnhome}scence-page/collect/service-3.png`,
            '开启调研',
            'right',
            {
              unButtons: this.hideButton,
              htmlTitle: "<span class='color-primary'>交付快</span> 通用样本1~3天交付",
              textStyle: { 'padding-left': '50px', 'padding-right': '0px' },
              textBkg: `${this.$cdnhome}scence-page/collect/text-bkg.png`,
              customClass: 'collect-post',
            }
          ),
        ],
        [
          '价格低 样本单价0.9元起',
          createObject(
            [
              '问卷网的定价策略旨在提供具有竞争力的价格，确保您在获得高质量服务的同时，也能享受到合理的成本效益',
              '我们承诺无隐藏费用，所有价格都会在项目开始前明确告知',
            ],
            `${this.$cdnhome}scence-page/collect/service-4.png`,
            `${this.$cdnhome}scence-page/collect/service-4.png`,
            '开启调研',
            'left',
            {
              unButtons: this.hideButton,
              htmlTitle: "<span class='color-primary'>价格低</span> 样本单价0.9元起",
              textStyle: { 'padding-left': '0px', 'padding-right': '50px' },
              textBkg: `${this.$cdnhome}scence-page/collect/text-bkg.png`,
              customClass: 'collect-post',
            }
          ),
        ],
      ]),
    }
  },
  computed: {
    isMobile() {
      return this.$store.state.isMobile
    },
    ishandset() {
      return this.$store.state.innerWidth > 640
    },
    innerWidth() {
      return this.$store.state.innerWidth
    },
    type() {
      const { title, desc, src, mobileSrc, btnText, align } = this
      const obj = removeEmpty({
        desc,
        src,
        mobileSrc,
        btnText,
        align,
      })
      return {
        title,
        ...this.defData.get(title),
        ...obj,
      }
    },
    loggedIn() {
      return this.$store.state.loginStatus.loggedIn == 1
    },
  },
}
